import Gameplay from "slotworks/model/gameplay/gameplay-model";
import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";

class GameState {

    private netPosition: number = 0;

    private gameplay: Gameplay;

    public newGame(stake: number = 0) {
        let balance: number;

        if (this.gameplay) {
            balance = this.gameplay.balance;
        }

        this.gameplay = new Gameplay();
        this.gameplay.startBalance = this.gameplay.balance = balance;
        
        if (stake) {
            this.gameplay.startBalance -= stake;
            this.updateNetPosition(-stake);
            if (this.gameplay.startBalance < 0) {
                this.gameplay.startBalance = 0;
            }
        }
    }

    public getCurrentGame() {
        return this.gameplay || null;
    }

    public currentGameHasSymbolWinResults() {
        return this.gameplay && this.gameplay.getCurrentRecord() && this.gameplay.getCurrentRecord().getResultsOfType(SymbolWinResult).length > 0;
    }

    public getNetPosition() {
        return this.netPosition;
    }

    public updateNetPosition(value: number) {
        this.netPosition += value;
    }
}

export default new GameState();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/game-state.ts